import { graphql } from '@apollo/react-hoc';
import GetCentralClienteFrotaAtivoGql from './GetCentralClienteFrotaAtivoGql.graphql';

export const GetCentralClienteFrotaAtivoQueryGql = graphql(
  GetCentralClienteFrotaAtivoGql,
  {
    name: 'centralClienteFrotaAtivo',
  }
);
